import { useTranslation } from 'react-i18next';
import { useSettingsStore } from '@/lib/settings-store';
import styles from './EnhancedVoiceToggle.module.css';

/**
 * Settings-page row for the "Default new prayers to private" preference.
 * Reuses the visual pattern of EnhancedVoiceToggle so the Settings page
 * stays visually cohesive. The on-state fires the same posture change
 * that the onboarding prompt writes — one path, one source of truth.
 */
export default function DefaultPrivacyToggle() {
  const { t } = useTranslation();
  const defaultPrivate = useSettingsStore((s) => s.defaultPrivate);
  const setDefaultPrivate = useSettingsStore((s) => s.setDefaultPrivate);

  return (
    <div className={styles.wrapper}>
      <button
        type="button"
        role="switch"
        aria-checked={defaultPrivate}
        className={`${styles.row} ${defaultPrivate ? styles.on : ''}`}
        onClick={() => setDefaultPrivate(!defaultPrivate)}
      >
        <span className={styles.label}>{t('private.settingsDefaultLabel')}</span>
        <span className={styles.track} aria-hidden="true">
          <span className={styles.thumb} />
        </span>
      </button>
      <p className={styles.description}>{t('private.settingsDefaultHelper')}</p>
    </div>
  );
}
